import { Card, Divider, SkeletonBodyText, SkeletonDisplayText, SkeletonTabs } from "@shopify/polaris";
import { SkeletonRowWrapper } from "./styled";

const SkeletonTableLocations = () => {
  return (
    <Card>
      <SkeletonTabs count={3} />
      <Divider />
      <SkeletonRowWrapper>
        <SkeletonDisplayText size="small" />
        <SkeletonDisplayText size="small" />
        <SkeletonDisplayText size="small" />
        <SkeletonDisplayText size="small" />
      </SkeletonRowWrapper>
      <Divider />
      <SkeletonRowWrapper>
        {Array.from({ length: 12 }).map((_, index) => (
          <SkeletonBodyText key={index} lines={1} />
        ))}
      </SkeletonRowWrapper>
    </Card>
  )
};

export default SkeletonTableLocations;
